module.exports = {
  cardStyle: {
    style: {
      base: {
        color: '#ccc',
        iconColor: '#cf9',
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#fc9',
        },
      },
      invalid: {
        color: '#f9c',
        iconColor: '#f9c',
      },
    },
  },
};
